import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/facade/auth/auth.service';
import { NbToastrService } from '@nebular/theme';

@Component({
	selector: 'app-forgot-password-parent',
	templateUrl: './forgot-password-parent.component.html',
	styleUrls: ['./forgot-password-parent.component.scss']
})
export class ForgotPasswordParentComponent implements OnInit {
	userEmail = '';

	requesting = false;

	constructor(
		private authService: AuthService,
		private toastrService: NbToastrService
	) {}

	ngOnInit() {}

	handleForgotPassword(email) {
		this.requesting = true;

		this.authService.sendEmailForReset(email).subscribe(
			result => {
				this.userEmail = result['data']['createResetToken']['user'].email;

				this.showToast(
					`Linku për rivendosjen e fjalëkalimit është dërguar në ${this.userEmail}`,
					''
				);

				this.requesting = false;
			},
			error => {
				console.log(error);

				this.showToast('Ops, Ju lutem provoni përsëri!', '');

				this.requesting = false;
			}
		);
	}

	showToast(position, status) {
		this.toastrService.show(status, position);
	}
}
